import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TableInformation from 'src/components/quotations/printQuote/TableInformation';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { getField, formatQuotaionNumber, formatNumber } from 'src/common/helper';
import { getOfficialPaymantMethodName } from 'src/utils/nameMapping';

const border = '1px solid #0000001f';
const groupBox = {
  border: border,
  borderRadius: '4px',
};
const fontText = {
  fontSize: '14px',
  fontWeight: '500',
  lineHeight: '14.4px'
};

type PrintPaymentConfirmationProps = {
  detailData: any;
  amountData: any;
};

const PrintPaymentConfirmation: React.FC<PrintPaymentConfirmationProps> = (props) => {
  const [information, setInformation] = useState<any[]>([]);
  const [paymentInfo, setPaymentInfo] = useState<any[]>([]);

  const currentDate = new Date().toLocaleDateString('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).replace(/\//g, '-');

  const getInformation = () => {
    if (props.detailData) {
      const row1 = {
        label: getField(props.detailData, 'patientname', '-') + `(${getField(props.detailData, 'patientno', '-')})`,
        content: `発行日: ${currentDate}`
      }

      const row2 = {
        label: `医師: ${getField(props.detailData, 'doctor', '-')}`,
        content: `見積番号：${formatQuotaionNumber(getField(props.detailData, 'id', '0'))}`
      }

      setInformation((prevState: any) => [
        ...prevState,
        row1,
        row2
      ]);

      setPaymentInfo(getField(props.detailData, 'payments', []));
    }
  }

  useEffect(() => {
    setInformation([]);
    getInformation();
    // eslint-disable-next-line
  }, [props.detailData]);

  return (
    <Box sx={{
      width: '100%',
      '@media print': {
        p: '4mm'
      }
    }}>
      <Box sx={{ p: '3.96875mm' }}>
        <Stack spacing={'2.6458mm'}>
          <Box sx={{ ...groupBox, px: '3.96875mm' }}>
            <TableInformation items={information} title={'お支払い確認書'} />
          </Box>
          
          <Box sx={{ ...groupBox, p: '2.6458mm 3.96875mm' }}>
            <Box sx={{ ...fontText, lineHeight: '1.5' } }>
              <Typography>{'<お支払い状況>'}</Typography>
              <Box sx={{ py: '2.6458mm', display: 'flex', justifyContent: 'space-between', borderBottom: border }}>
                <Typography>ご請求金額</Typography>
                <Typography>{`¥ ${formatNumber(props.amountData.quoteTotal)}`}</Typography>
              </Box>
              <Box sx={{ py: '2.6458mm', borderBottom: border }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography>お支払い済み額</Typography>
                  <Typography>{`¥ ${formatNumber(getField(props.detailData, 'paymenttotal', 0))}`}</Typography>
                </Box>
                {paymentInfo.length > 0 && (
                  <Box sx={{ px: '3.96875mm' }}>
                    <TableContainer component={Box} sx={{ mt: '2.6458mm', border: border }}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ py: '4px', width: '35%' }}>お支払い日</TableCell>
                              <TableCell sx={{ py: '4px', width: '35%' }}>お支払い方法</TableCell>
                              <TableCell sx={{ py: '4px', width: '25%' }}>お支払い金額</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {paymentInfo.map((payment, index) => (
                              <TableRow key={index}>
                                <TableCell sx={{ py: '4px' }}>{payment.paymentdate}</TableCell>
                                <TableCell sx={{ py: '4px' }}>{getOfficialPaymantMethodName(payment.method)}</TableCell>
                                <TableCell sx={{ py: '4px' }}>{`¥ ${formatNumber(payment.amount)}`}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                  </Box>
                )}
              </Box>
              <Box sx={{ py: '2.6458mm', display: 'flex', justifyContent: 'space-between' }}>
                <Typography fontSize={'16px'} fontWeight={600}>お支払い残金</Typography>
                <Typography fontSize={'16px'} fontWeight={600}>{`¥ ${formatNumber(props.amountData.unpaid)}`}</Typography>
              </Box>
            </Box>
          </Box>
          
          <Box sx={{ ...groupBox, p: '2.6458mm 3.96875mm' }}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <Box sx={{ '& .MuiTypography-root': { ...fontText, lineHeight: '1.5' } }}>
                <Typography>
                  {'<振込先口座>'}
                </Typography>
                <Typography>
                  {'三菱ＵＦＪ銀行　　0005'}
                </Typography>
                <Typography>
                  {'江坂支店　074'}
                </Typography>
                <Typography>
                  {'普通　0430121'}
                </Typography>
                <Typography>
                  {'シヤ）ニホンビヨウイリヨウケンキユウキコウ'}
                </Typography>
              </Box>
              <Box sx={{ alignContent: 'center', '& .MuiTypography-root': { ...fontText, lineHeight: '1.5' } }}>
                <Typography>
                  {'リゾナスフェイスクリニック東京'}
                </Typography>
                <Typography>
                  {'メール  reserveTOKYO@resonusfc.com'}
                </Typography>
                <Typography>
                  {`受付担当: ${getField(props.detailData, 'fullname', '')}`}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Stack>
      </Box >
    </Box >
  );
}

export default PrintPaymentConfirmation;
